export default "__VITE_ASSET__CecFyMLp__"